import React from "react";
import { Col, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { InputBox } from "../../components";

import { ApiHelper, FeedInterface, SubscriptionInterface, UserHelper, ToastHelper } from "../../helpers";
import { OrangeModal } from "./OrangeModal";


interface Props {
  feed: FeedInterface
}



export const ManageFeed: React.FC<Props> = props => {

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [subscription, setSubscription] = React.useState<SubscriptionInterface>(null);
  const [redirect, setRedirect] = React.useState("");
  const [showOrangeModal, setShowOrangeModal] = React.useState(false);

  const init = () => {
    ApiHelper.get<SubscriptionInterface>("/subscriptions/feed/" + props.feed?.id).then((data) => {
      setSubscription(data);
    });
  }

  React.useEffect(init, [props.feed])

  const checkCanSubscribe = () => {
    if (!UserHelper.checkAccess("owner")) alert("Unable to subscribe since you are not the account owner.");
    else {
      if (props.feed.id===98 || props.feed.id===99) setShowOrangeModal(true);
      
      else handleSubscribe();
    }
  }

  const handleSubscribe = (data?:string) => {
    setIsSubmitting(true);
    ApiHelper.post("/feeds/" + props.feed.id + "/subscribe", {data}).then(data => {
      init();
      setIsSubmitting(false);
    });
  }

  /*
  const handleOrangeSubscribe = (data:string) => {
    
    ApiHelper.post("/feeds/" + props.feed.id + "/subscribe", {data}).then(sub => {
      const url = "/playlists/0?subscriptionId=" + sub.id + data
      setRedirect(url);
    });
  }
    */

  const handleUnsubscribe = () => {
    if (UserHelper.checkAccess("owner")) {
      setIsSubmitting(true);
      ApiHelper.post<{ errors?: string[] }>("/feeds/" + props.feed.id + "/unsubscribe", {}).then(data => {
        if (data?.errors) {
          data.errors.forEach((error: string) => ToastHelper.error(error));
        } else {
          ToastHelper.success("Unsubscribed successfully");
          init();
        }
        setIsSubmitting(false);
      });
    } else alert("Unable to subscribe since you are not the account owner.");
  }

  const getPriceDetails = () => {
    let formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    let displayPrice = <></>;
    let trial = <></>;
    if ((props.feed.monthlyAccountFee > 0 || props.feed.additionalScreenFee > 0) && props.feed.trialDays > 0) trial = <><br />{props.feed.trialDays} day free trial</>
    if (props.feed.monthlyAccountFee === 0 && props.feed.additionalScreenFee === 0) displayPrice = <h4>Free</h4>;
    else if (props.feed.additionalScreenFee === 0) {
      displayPrice = <>
        <b>{formatter.format(props.feed.monthlyAccountFee)}</b><br />
        <i>Unlimited Screens</i>
        {trial}
      </>;
    }
    else if (props.feed.monthlyAccountFee === 0 && props.feed.additionalScreenFee > 0) {
      displayPrice = <>
        First Screen: <b>Free</b><br />
        Additional Screens: <b>{formatter.format(props.feed.additionalScreenFee)}/mo</b>
        {trial}
      </>;
    } else {
      displayPrice = <>
        First Screen: <b>{formatter.format(props.feed.monthlyAccountFee)}/mo</b>
        Additional Screens: <b>{formatter.format(props.feed.additionalScreenFee)}/mo</b>
        {trial}
      </>;
    }
    return (<Row>
      <Col sm={4}><h4>Price:</h4></Col>
      <Col sm={8}>{displayPrice}</Col>
    </Row>);
  }

  const createPlaylist = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const shape: string = urlParams.get("shape");
    if (!shape) setRedirect("/playlists/0?subscriptionId=" + subscription.id);
    else setRedirect("/playlists/0?subscriptionId=" + subscription.id + "&shape=" + shape);
  }

  if (redirect !== "") return <Navigate to={redirect} replace />
  else if (subscription) {
    const hasPlaylist = props.feed.mode === "Playlist" || props.feed.mode === "Both";
    const hasLibrary = props.feed.mode === "Library" || props.feed.mode === "Both";
    const saveFunction = (hasPlaylist) ? createPlaylist : null;
    const saveText = (hasPlaylist) ? "Create Playlist" : null;

    const libraryMessage = (hasLibrary) ? <p>The messages from this feed are available to add to any playlist.</p> : <></>

    return (
      <InputBox headerIcon="fas fa-satellite-dish" headerText="Manage Feed" deleteText="Unsubscribe" deleteFunction={handleUnsubscribe} isSubmitting={isSubmitting} saveText={saveText} saveFunction={saveFunction} >
          {getPriceDetails()}
          {libraryMessage}
      </InputBox>
    );
  } else {
    return (
      <InputBox headerIcon="fas fa-satellite-dish" headerText="Manage Feed" saveText="Subscribe" saveFunction={checkCanSubscribe} isSubmitting={isSubmitting} >
        {getPriceDetails()}
        {showOrangeModal && <OrangeModal onClose={() => setShowOrangeModal(false)} onDone={(data:string) => { handleSubscribe(data);  }}  />}
      </InputBox>
    );
  }

};